import React from "react";
import {
  ButtonVariant,
  Divider,
  Menu,
  Radio,
  RadioGroup,
} from "@merge-api/merge-javascript-shared";
import { LinkedAccountStatuses } from "../../../../../../../constants";
import { LinkedAccountsFilters } from "../../../hooks/useLinkedAccountsFilters";

interface Props {
  filters: LinkedAccountsFilters;
  onFiltersChange: (filters: LinkedAccountsFilters) => void;
  disabled?: boolean;
}

const SHOW_ALL = "ALL";

const STATUS_OPTIONS = [
  { label: "Linked", value: LinkedAccountStatuses.COMPLETE },
  { label: "Relink", value: LinkedAccountStatuses.RELINK_NEEDED },
  { label: "Incomplete", value: LinkedAccountStatuses.INCOMPLETE },
  { label: "Idle", value: LinkedAccountStatuses.IDLE },
];

const LinkedAccountsFilterPopover = ({ filters, onFiltersChange, disabled }: Props) => {
  const onValueChange = (status: string) => {
    onFiltersChange({ ...filters, status: status === SHOW_ALL ? null : status });
  };

  return (
    <Menu
      menuPlacement="bottom-start"
      ButtonProps={{
        variant: ButtonVariant.TertiaryWhite,
        disabled,
        children: "Filter",
      }}
    >
      <div className="p-3">
        <RadioGroup
          value={filters.status ?? SHOW_ALL}
          onValueChange={onValueChange}
          className="flex flex-col gap-2"
        >
          <Radio value={SHOW_ALL} label="Show all" />
          <Divider />
          {STATUS_OPTIONS.map((option) => (
            <Radio key={option.value} value={option.value} label={option.label} />
          ))}
        </RadioGroup>
      </div>
    </Menu>
  );
};

export default LinkedAccountsFilterPopover;
